import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { catchError, map, Observable } from 'rxjs';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class DisposermanageService {
  private getAllEndpoint = environment.ECO_WASTE_SERVICE_URL + '/Disposer/GetAllActive';
  private getByIdEndpoint = environment.ECO_WASTE_SERVICE_URL + '/Disposer/GetById';
  private createDisposerEndpoint = environment.ECO_WASTE_SERVICE_URL + '/Disposer/Create';
  private updateDisposerEndpoint = environment.ECO_WASTE_SERVICE_URL + '/Disposer/Update';
  private deleteEndpoint = environment.ECO_WASTE_SERVICE_URL + '/Disposer/DeleteById';

  private getDriverByDisposerIdEndpoint = environment.ECO_WASTE_SERVICE_URL + '/Disposer/GetDriverByDisposerId';
  private createDriverEndpoint = environment.ECO_WASTE_SERVICE_URL + '/Disposer/CreateDriver';
  private uploadDriverEndpoint = environment.ECO_WASTE_SERVICE_URL + '/Disposer/UploadDriver';
  private updateDriverEndpoint = environment.ECO_WASTE_SERVICE_URL + '/Disposer/UpdateDriver';
  private deleteDriverByIdEndpoint = environment.ECO_WASTE_SERVICE_URL + '/Disposer/DeleteDriverById';

  private getTransporterByDisposerIdEndpoint = environment.ECO_WASTE_SERVICE_URL + '/Disposer/GetTransporterByDisposerId';
  private createTransporterEndpoint = environment.ECO_WASTE_SERVICE_URL + '/Disposer/CreateTransporter';
  private updateTransporterEndpoint = environment.ECO_WASTE_SERVICE_URL + '/Disposer/UpdateTransporter';
  private deleteTransporterByIdEndpoint = environment.ECO_WASTE_SERVICE_URL + '/Disposer/DeleteTransporterById';
  private getProvinceDropDownEndpoint = environment.ECO_WASTE_SERVICE_URL + '/Disposer/GetProvinceDropDown';
  
  private createLicenseEndpoint = environment.ECO_WASTE_SERVICE_URL + '/Disposer/CreateLicense';
  private updateLicenseEndpoint = environment.ECO_WASTE_SERVICE_URL + '/Disposer/UpdateLicense';
  private deleteLicenseEndpoint = environment.ECO_WASTE_SERVICE_URL + '/Disposer/DeleteLicenseById';

  private getAllDisposerGroupEndpoint = environment.ECO_WASTE_SERVICE_URL + '/Disposer/GetAllDisposerGroup';
  private getDisposerDropdownEndpoint = environment.ECO_WASTE_SERVICE_URL + '/Disposer/GetDisposerDropdown';
  private getDisposerGroupByIdEndpoint = environment.ECO_WASTE_SERVICE_URL + '/Disposer/GetDisposerGroupById';
  private createDisposerGroupEndpoint = environment.ECO_WASTE_SERVICE_URL + '/Disposer/CreateDisposerGroup';
  private updateDisposerGroupEndpoint = environment.ECO_WASTE_SERVICE_URL + '/Disposer/UpdateDisposerGroup';
  private deleteDisposerGroupByIdEndpoint = environment.ECO_WASTE_SERVICE_URL + '/Disposer/DeleteDisposerGroupById';

  private getDisposalMethodDropdownEndpoint = environment.ECO_WASTE_SERVICE_URL + '/DisposalMethod/GetDropDown';


  constructor(private http: HttpClient) { }

  getAllDisposers(): Observable<any[]> {
    return this.http.get<any[]>(this.getAllEndpoint);
  }

  getDisposerById(id: any): Observable<any> {
    const url = `${this.getByIdEndpoint}/?id=${id}`;
    return this.http.get<any>(url);
  }

  createDisposer(disposerForm: any): Observable<any> {
    const url = `${this.createDisposerEndpoint}`;
    const headers = new HttpHeaders({
      'Content-Type': 'application/json',
      'accept': '*/*'
    });
    return this.http.post(url, disposerForm, { headers: headers });
  }

  updateDisposer(disposerForm: any): Observable<any> {
    console.log("Service", disposerForm)
    const url = `${this.updateDisposerEndpoint}`;
    return this.http.put(url, disposerForm);
  }

  getDriverByDisposerId(disposerId: any): Observable<any> {
    const url = `${this.getDriverByDisposerIdEndpoint}/?disposerId=${disposerId}`;
    return this.http.get<any>(url);
  }

  deleteDisposerById(disposerId: number): Observable<any> {
    const url = `${this.deleteEndpoint}?id=${disposerId}`;
    const headers = new HttpHeaders({
      'Content-Type': 'application/json',
      'accept': '*/*'
    });
    return this.http.put(url, {}, { headers: headers });
  }

  createDriver(disposerId: number, driverForm: any): Observable<any> {
    const url = `${this.createDriverEndpoint}?disposerId=${disposerId}`;
    const headers = new HttpHeaders({
      'Content-Type': 'application/json',
      'accept': '*/*'
    });
    return this.http.post(url, driverForm, { headers: headers });
  }

  uploadDriver(disposerId: number, driverForm: any): Observable<any> {
    const url = `${this.uploadDriverEndpoint}?disposerId=${disposerId}`;
    const headers = new HttpHeaders({
      'Content-Type': 'application/json',
      'accept': '*/*'
    });
    return this.http.post(url, driverForm, { headers: headers });
  }


  updateDriverById(id: number, driverData: any): Observable<any> {
    const url = `${this.updateDriverEndpoint}`;
    const body = { id, ...driverData };
    console.log(body)
    return this.http.put(url, body);
  }

  deleteDriverById(driverId: number): Observable<any> {
    const url = `${this.deleteDriverByIdEndpoint}?id=${driverId}`;
    const headers = new HttpHeaders({
      'Content-Type': 'application/json',
      'accept': '*/*'
    });
    return this.http.put(url, {}, { headers: headers });
  }

  getTransporterByDisposerId(disposerId: any): Observable<any> {
    const url = `${this.getTransporterByDisposerIdEndpoint}/?disposerId=${disposerId}`;
    return this.http.get<any>(url);
  }

  getProvincesDropDown(): Observable<any> {
    const url = `${this.getProvinceDropDownEndpoint}`;
    return this.http.get<any>(url);
  }

  createTransporter(disposerId: number, transporterForm: any): Observable<any> {
    console.log(transporterForm)
    const url = `${this.createTransporterEndpoint}?disposerId=${disposerId}`;
    const headers = new HttpHeaders({
      'Content-Type': 'application/json',
      'accept': '*/*'
    });
    return this.http.post(url, transporterForm, { headers: headers });
  }


  updateTrasnporterById(id: number, transporterData: any): Observable<any> {
    const url = `${this.updateTransporterEndpoint}`;
    const body = { id, ...transporterData };
    console.log(body)
    return this.http.put(url, body);
  }

  deleteTransporterById(transporterId: number): Observable<any> {
    const url = `${this.deleteTransporterByIdEndpoint}?id=${transporterId}`;
    const headers = new HttpHeaders({
      'Content-Type': 'application/json',
      'accept': '*/*'
    });
    return this.http.put(url, {}, { headers: headers });
  }

  getAllDisposerGroup(): Observable<any[]> {
    return this.http.get<any[]>(this.getAllDisposerGroupEndpoint);
  }

  getAllDisposer(): Observable<any[]> {
    return this.http.get<any[]>(this.getDisposerDropdownEndpoint);
  }

  getDisposerGroupById(diposerGroupId: any): Observable<any> {
    const url = `${this.getDisposerGroupByIdEndpoint}/?id=${diposerGroupId}`;
    return this.http.get<any>(url);
  }

  deleteDisposerGroupById(disposerGroupId: number): Observable<any> {
    const url = `${this.deleteDisposerGroupByIdEndpoint}?id=${disposerGroupId}`;
    const headers = new HttpHeaders({
      'Content-Type': 'application/json',
      'accept': '*/*'
    });
    return this.http.put(url, {}, { headers: headers });
  }

  createDisposerGroup(disposerGroupData: any): Observable<any> {
    console.log("Service: ", disposerGroupData)
    return this.http.post<any>(this.createDisposerGroupEndpoint, disposerGroupData);
  }

  updateDisposerGroup(disposerGroupData: any): Observable<any> {
    console.log("Service: ", disposerGroupData)
    return this.http.put<any>(this.updateDisposerGroupEndpoint, disposerGroupData);
  }

  getDisposalMethodDropdown(): Observable<any[]> {
    return this.http.get<any[]>(this.getDisposalMethodDropdownEndpoint);
  }

  createLicense(license: any): Observable<any> {
    console.log("Service: ", license)
    
    return this.http.post<any>(`${this.createLicenseEndpoint}`, license).pipe(map(res => res));;
  }

  updateLicense(license: any): Observable<any> {
    console.log("Service: ", license)
    
    return this.http.put<any>(`${this.updateLicenseEndpoint}`, license).pipe(map(res => res));;
  }

  deleteLicense(license: any): Observable<any> {
    const url = `${this.deleteLicenseEndpoint}?id=${license}`;
    const headers = new HttpHeaders({
      'Content-Type': 'application/json',
      'accept': '*/*'
    });
    return this.http.put(url, {}, { headers: headers });
  }
}
